export default __webpack_public_path__ + "static/media/OutlinedPhone.a6cf9085.svg";